import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { dbService } from "../../firebaseInstance";
import { getProfilePure } from "../../utils/pureDataFetch";
import { useUserDispatch, UserTypes } from "../../contexts/UserContext";
import { arrayUnion } from "firebase/firestore";
const Callback = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const clientId = "511936531788597";
	const clientSecret = "1e94ec81ac12344d576f2851834e7235";
	const redirectUri = `${window.location.origin}/callback`;
	const dispatch = useUserDispatch();

	useEffect(() => {
		const authorizationCode = new URLSearchParams(location.search).get("code");
		if (authorizationCode) {
			console.log(authorizationCode);
			console.log(redirectUri);
			// Clear existing tokens before exchanging the new code
			localStorage.removeItem("accessToken");
			localStorage.removeItem("userID");
			exchangeCodeForToken(authorizationCode);
		}
	}, [location]);

	// Get a Long-Lived Token
	const getLongLivedToken = async (accessToken) => {
		const url = "https://graph.threads.net/access_token";
		try {
			const response = await axios.get(url, {
				params: {
					client_secret: clientSecret,
					grant_type:"th_exchange_token",
					access_token: accessToken,
				},
			});
			console.log("response from Long-Lived for token", response);

			const longLivedaccessToken = response.data.access_token;	//LONG_LIVED_USER_ACCESS_TOKEN
			const tokenType = response.data.token_type;
			const expiresIn = response.data.expires_in;	// 토큰이 만료될 때까지의 시간(초)

			return response;
		} catch (error) {
			console.error("Error during Long-Lived Token:", error);
			navigate("/error");
		}
	};

	// Refesh Long-Lived Token
	const refreshLongLivedToken = async (requestLongLivedaccessToken) => {
		const url = "https://graph.threads.net/refresh_access_token";
		try {
			const response = await axios.get(url, {
				params: {
					grant_type:"th_refresh_token",
					access_token: requestLongLivedaccessToken,
				},
			});
			console.log("response from refresh Long-Lived for token", response);

			const longLivedaccessToken = response.data.access_token;	//LONG_LIVED_USER_ACCESS_TOKEN
			const tokenType = response.data.token_type;
			const expiresIn = response.data.expires_in;	// 토큰이 만료될 때까지의 시간(초)

			return response;
		} catch (error) {
			console.error("Error during Long-Lived Token:", error);
			navigate("/error");
		}
	};

	const exchangeCodeForToken = async (authorizationCode) => {
		const url = "https://graph.threads.net/oauth/access_token";
		try {
			const response = await axios.post(url, null, {
				params: {
					client_id: clientId,
					client_secret: clientSecret,
					redirect_uri: redirectUri,
					code: authorizationCode,
					grant_type: "authorization_code",
				},
			});

			console.log("response from exchange code for token", response);

			const accessToken = response.data.access_token;
			const longLivedTokenResponse = await getLongLivedToken(accessToken);
			console.log("longLivedTokenResponse", longLivedTokenResponse);
			const longLivedToken = longLivedTokenResponse.data.access_token;
			console.log("longLivedToken : ", longLivedToken);
			localStorage.setItem("longLivedToken", longLivedToken);

			// Fetch user profile data
			localStorage.setItem("accessToken", accessToken);
			const profileData = await getProfilePure(accessToken);
			console.log("profileResponse with access token", profileData);
			console.log("id from exchange code for token", response.data.user_id);
			console.log("id from profile response", profileData.id);
			localStorage.setItem("userID", profileData.id);

			const id = profileData.id;

			// Store in Firestore
			const userDocRef = dbService.collection("user").doc(id);

			console.log("get user id from access token", id);

			let userData;
			try {
				const userDoc = await userDocRef.get();
				console.log("check if user doc exists", userDoc);
				if (!userDoc.exists) {
					// Only create new document if it doesn't exist
					userData = {
						...response.data,
						user_id: profileData.id,
						visitLog: arrayUnion(new Date().toISOString()),
						profile: {
							...profileData,
							signUpDate: new Date().toISOString(),
						},
					};
					console.log("create new user doc", userData);
					await userDocRef.set(userData).catch((error) => {
						console.error("Error creating user document:", error);
						throw new Error("Failed to create user document");
					});
					console.log("Sign up");
				} else {
					// Update existing document
					userData = {
						...response.data,
						user_id: profileData.id,
						visitLog: arrayUnion(new Date().toISOString()),
						profile: {
							...profileData,
							signUpDate: userDoc.data().profile.signUpDate,
						},
					};
					console.log("update existing user doc", userData);
					await userDocRef.update(userData).catch((error) => {
						console.error("Error updating user document:", error);
						throw new Error("Failed to update user document");
					});
					console.log("Sign in");
				}
				// Store in context
				console.log("setting profile in context with userData", userData);
				dispatch({
					type: UserTypes.SET_PROFILE,
					payload: {
						...userData,
						accessToken: response.data.access_token,
					},
				});
			} catch (firestoreError) {
				console.error("Firestore operation failed:", firestoreError);
				navigate("/error");
				return;
			}
			console.log("navigating to dashboard");
			navigate("/dashboard");
		} catch (error) {
			console.error("Error during authentication:", error);
			navigate("/error");
		}
	};

	return <div>Processing...</div>;
};

export default Callback;
